// extracted by mini-css-extract-plugin
export default {"container":"myFocusHeader_container__5dd2j","content":"myFocusHeader_content__6zCy4"};